import PoolDescription, { I18N_CONTEXT } from './crowdfunding_story'
import { getI18n } from 'client/i18n'
import { reduxForm } from 'redux-form'
import _get from 'lodash/get'
import { CROWDFUNDING_DESCRIPTION_LENGTH } from 'shared/lengths'
import { required, length, combine } from 'lib/validators'
import formUtils from 'lib/form_utils'
import { push } from 'react-router-redux'

import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getTranslatedCategoryList, isValidCategory } from 'lib/category'
import { trackClick } from 'lib/fpti_analytics'

const i18n = getI18n(I18N_CONTEXT)

let validators = [
  required('description', i18n('description_required')),
  length(
    'description',
    CROWDFUNDING_DESCRIPTION_LENGTH,
    i18n('description_too_long', {
      maxLength: CROWDFUNDING_DESCRIPTION_LENGTH,
    })
  ),
]

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const categoryList = getTranslatedCategoryList(state)
  const categoryQueryParam = _get(state, 'queryParams.category')
  // category initial/default value
  const category =
    campaign.category ||
    (isValidCategory(state, categoryQueryParam)
      ? categoryQueryParam
      : categoryList[0].value)

  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    initialValues: {
      category,
      description: campaign.description,
    },
    categoryList,
  }
}

const mapDispatchToProps = dispatch => {
  // event_name is hardcoded for crowdfunding phase 1
  return {
    onSubmit(formValues) {
      trackClick({
        clickName: 'next',
        data: {
          flow: 'crowdfunding',
        },
      })
      dispatch(
        setData(NEW_CAMPAIGN_ID, {
          description: formValues.description,
          category: formValues.category,
          event_name: 'COVID-19',
        })
      )
      dispatch(
        push({
          pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/cover`,
        })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'crowdfunding_story',
    destroyOnUnmount: false,
    fields: ['category', 'description'],
    touchOnBlur: true,
    touchOnChange: false,
    validate: combine(...validators),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(PoolDescription))
